import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
  Label,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetClientSystems,
  resetError,
  getClientSystems,
  deleteClientSystem,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import Select from "react-select";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { isArray } from "../../Libs/CustomMethods/customMethods";

const ClientSystems = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataClientSystem,
    dataClientSystemDelete,
    loadingClientSystem,
    loadingClientSystemDelete,
    errorClientSystem,
    successClientSystem,
  } = useSelector((state) => state.ClientSystems);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [clientSystemId, setClientSystemId] = useState("");
  const [clientSystemName, setClientSystemValue] = useState("");

  const [clientFilter, setClientFilter] = useState("");
  const [variableFilter, setVariableFilter] = useState("");
  const [valueFilter, setValueFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successClientSystem && dispatch(resetClientSystems()) && handleFilter(),
  };

  const handleFilter = (variable, value) => {
    setVariableFilter(variable);
    setValueFilter(value);
    setPage(1);
    dispatch(
      getClientSystems(null, 1, qtdDefault, clientFilter, variable, value, true)
    );
  };

  const handleDelete = () => {
    dispatch(deleteClientSystem(clientSystemId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setClientSystemIdName = (clientSystem) => {
    setClientSystemId(clientSystem.id);
    setClientSystemValue(clientSystem.value);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(
      getClientSystems(
        null,
        value,
        qtdDefault,
        clientFilter,
        variableFilter,
        valueFilter,
        true
      )
    );
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataClientSystem && dataClientSystem.paging) {
      if (page < dataClientSystem.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const optionsCompany = () => {
    let companies = [];
    companies.push({ key: 0, value: null, label: t("All Companies") });

    dataClientSystem?.form?.clients &&
      dataClientSystem.form.clients.map((company, key) =>
        companies.push({ key: key + 1, value: company.id, label: company.name })
      );

    return companies;
  };

  useEffect(() => {
    if (dataClientSystemDelete?.message) {
      showToast("success", t(dataClientSystemDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successClientSystem]);

  useEffect(() => {
    if (isArray(errorClientSystem)) {
      errorClientSystem.forEach((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorClientSystem) {
        showToast("error", t(errorClientSystem));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorClientSystem]);

  useEffect(() => {
    if (dataClientSystem !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataClientSystem]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/clientsystemvariables"
            title={t("Dashboard")}
            breadcrumbItem={t("Client System Variables")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.variable, values.value);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup className="select2-container">
                          <Label className="control-label">
                            {t("Company")}
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            className="w-100 mb-3"
                            placeholder={t("Company") + "..."}
                            options={optionsCompany()}
                            isLoading={loadingClientSystem}
                            isSearchable
                            onChange={(e) => {
                              setClientFilter(e.value);
                            }}
                            noOptionsMessage={() =>
                              t("No matching records found")
                            }
                            value={optionsCompany().find(
                              (item) => item.value === clientFilter
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Variable")}
                            id="variable"
                            name="variable"
                            type="text"
                            className="form-control"
                            placeholder={t("Variable") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Value")}
                            id="value"
                            name="value"
                            type="text"
                            className="form-control"
                            placeholder={t("Value") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div
                          className="text-sm-right mb-3"
                          id="new-clientSystem"
                        >
                          <Link to={`/clientsystemvariable`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Client System Variable")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("Client")}</th>
                            <th>{t("Variable")}</th>
                            <th className="w-100">{t("Value")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingClientSystem ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataClientSystem?.clientSystems?.length >
                            0 ? (
                            dataClientSystem?.clientSystems?.map(
                              (system, key) => (
                                <tr key={key}>
                                  <td>
                                    <div className="py-3">
                                      {system.client_name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="py-3">
                                      {system.client_system_variables_name}
                                    </div>
                                  </td>
                                  <td style={{ maxWidth: 50 }}>
                                    <PerfectScrollbar className="py-3">
                                      {system.value}
                                    </PerfectScrollbar>
                                  </td>
                                  <td>
                                    <div className="d-flex py-3">
                                      <Link
                                        to={`/clientsystemvariable/${system.id}`}
                                        className="text-primary text-center"
                                        id="edit"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18 px-2"
                                          id="edittooltip"
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="edittooltip"
                                        >
                                          {t("Edit")}
                                        </UncontrolledTooltip>
                                      </Link>
                                      <div style={{ cursor: "pointer" }}>
                                        <i
                                          className="mdi mdi-window-close text-danger font-size-18 px-2"
                                          id="deletetooltip"
                                          onClick={() => {
                                            toggleModal();
                                            setClientSystemIdName(system);
                                          }}
                                        ></i>
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="deletetooltip"
                                        >
                                          {t("Delete")}
                                        </UncontrolledTooltip>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingClientSystemDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t(
                            "Do you want to delete the client system variable"
                          )}
                          <strong> {clientSystemName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingClientSystemDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (clientSystemId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>

                  {dataClientSystem &&
                  dataClientSystem.paging &&
                  dataClientSystem.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataClientSystem?.paging?.map((value, index) => {
                        return (
                          <PaginationItem
                            key={index}
                            onClick={() => {
                              handlePage(value);
                            }}
                            active={page === value ? true : false}
                          >
                            <PaginationLink
                              key={index}
                              style={{ display: "inline" }}
                            >
                              {value}
                            </PaginationLink>
                          </PaginationItem>
                        );
                      })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(ClientSystems);
